import refineLink from '@/components/account/history/trades/refine-link/refine-link.vue';

export default {
  props: {
    list: Array,
  },
  components: {
    refineLink,
  },
  methods: {
    onClick(e) {
      this.$emit('input', e);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/account/history/trades/refine-history/refine-history.js